var map = {
	"./brick-mortar.svg": "c8d6",
	"./brick_and_mortar.svg": "b381",
	"./charitable_brand_give_back.svg": "1e68",
	"./clean_ingredients.svg": "5c70",
	"./ethical_production.svg": "e1d0",
	"./female_founded.svg": "7bd7",
	"./handmade.svg": "1f67",
	"./made_in_the_us.svg": "6c4a",
	"./minority_owned_business.svg": "8cb5",
	"./online.svg": "0b94",
	"./pop_up.svg": "d3b9",
	"./sustainable.svg": "97a3"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "f971";